<template>
  <div class="profile">
    <user-info :userInfo="userInfo" :isShowFansBar="true" />
    <div class="content-bg">
      <div class="attent">
        <span
          class="attrnt-item"
          :class="{ active: currentIndex === 0 }"
          @click="itemClick(0)"
          >发布过的({{ userInfo.topics_count }})</span
        >
        <span
          class="attrnt-item"
          :class="{ active: currentIndex === 1 }"
          @click="itemClick(1)"
          >点赞过的({{ userInfo.like_topic_count }})</span
        >
        <span
          class="attrnt-item"
          :class="{ active: currentIndex === 2 }"
          @click="itemClick(2)"
          >评论过的({{ userInfo.reply_topic_count }})</span
        >
      </div>
      <div v-show="currentIndex === 0" class="content-release">
        <collect-item :tag="1" :topics="myTopics" @loadMore="collLoadMore" />
      </div>
      <div v-show="currentIndex === 1" class="content-attent">
        <collect-item :tag="2" :topics="likesList" @loadMore="likeLoadMore" />
      </div>
      <div v-show="currentIndex === 2" class="content-release">
        <collect-item :tag="2" :topics="replyList" @loadMore="replyLoadMore" />
      </div>
    </div>
  </div>
</template>
<script>
import UserInfo from "./child/UserInfo";
import AttentItem from "./child/AttentItem";
import CollectItem from "./child/CollectItem";

import {
  getUserInfo,
  getPics,
  getLikeTopics,
  getReplyTopics,
  getAchievements,
} from "network/profile";

export default {
  name: "Profile",
  components: {
    UserInfo,
    AttentItem,
    CollectItem,
  },
  data() {
    return {
      userInfo: {},
      currentIndex: 0, //当前选中的（点赞的帖子，我的发帖，评论过的帖子）
      likesList: [], //点赞的帖子
      myTopics: [], //我的发帖
      replyList: [], //评论过的帖子
      topicsPage: 1,
      likePage: 1,
      replayPage: 1,
    };
  },
  computed: {},
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.getMyTopics();
    this.getLikeTopics();
    this.getReplyTopics();
    this.getAchievements();
  },
  mounted() {
    const from = localStorage.getItem("from");
    getUserInfo().then((res) => {
      this.userInfo = res.data;
      localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
    });
  },
  methods: {
    /**
     * 点击事件
     */
    itemClick(index) {
      if (this.currentIndex === index) {
        return;
      }
      this.currentIndex = index;
    },

    /**
     * 请求
     */

    //我发布过的
    getMyTopics() {
      let params = { page: this.topicsPage, user_id: this.userInfo.id };
      getPics(params).then((res) => {
        this.myTopics = res.data;
      });
    },
    //点赞过的列表
    getLikeTopics() {
      getLikeTopics(this.likePage).then((res) => {
        this.likesList = res.data;
      });
    },
    //评论过的帖子
    getReplyTopics() {
      getReplyTopics(this.replayPage).then((res) => {
        this.replyList = res.data;
      });
    },
    //发布过加载更多
    collLoadMore(callback) {
      let params = { page: ++this.topicsPage, user_id: this.userInfo.id };
      getPics(params).then((res) => {
        this.myTopics = this.myTopics.concat(res.data);
        if (res.data.length < 20) {
          callback(true);
        } else {
          callback(false);
        }
      });
    },
    //点赞的帖子
    likeLoadMore(callback) {
      this.likePage++;
      getLikeTopics(this.likePage).then((res) => {
        this.likesList = this.likesList.concat(res.data);
        if (res.data.length < 20) {
          callback(true);
        } else {
          callback(false);
        }
      });
    },
    //评论过的帖子
    replyLoadMore(callback) {
      this.replayPage++;
      getReplyTopics(this.replayPage).then((res) => {
        this.replyList = this.replyList.concat(res.data);
        if (res.data.length < 20) {
          callback(true);
        } else {
          callback(false);
        }
      });
    },
    //我的成就
    getAchievements() {
      getAchievements().then((res) => {});
    },
  },
};
</script>
<style scoped>
.profile {
  background: #f5f5f5;
  min-height: 100vh;
}
.content-bg {
  margin: 20px 15px 0px 15px;
  border-radius: 10px;
  background-color: #fff;
}
.attent {
  display: flex;
  padding: 15px 0;
  border-radius: 10px;
  background-color: #fff;
}
.attrnt-item {
  flex: 1;
  font-size: 14px;
  text-align: center;
  color: #333;
}

.content-release {
  margin: 0 15px 0px 15px;
  display: flex;
  flex-wrap: wrap;
  min-height: 280px;
  justify-content: space-between;
  color: #fff;
}
.active {
  font-weight: 700;
}
.content-attent {
  margin: 0 15px 0px 15px;
  padding-bottom: 10px;
  min-height: 280px;
}
</style>